// These match the db
export enum RunStatusAPI {
    InProgress = 1,
    Done = 2,
}

// Frontend-only status. 
export enum RunStatus {
    Initial = 'Initial',
    Starting = 'Starting',
    Running = 'Running',
    Canceling = 'Canceling',
}